import Dialog from "./Dialog"

export default function ConfirmDialog({
  isOpen,
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
  isProcessing = false,
  errorMessage = "",
}) {
  return (
    <Dialog isOpen={isOpen} onClose={onCancel} title={title}>
      <div className="confirm-dialog__content">
        <p className="confirm-dialog__message">{message}</p>
        {errorMessage && (
          <p className="dialog__error" role="alert">
            {errorMessage}
          </p>
        )}
        <div className="dialog__footer">
          <button
            type="button"
            className="button--secondary"
            onClick={onCancel}
            disabled={isProcessing}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className="button--danger"
            onClick={onConfirm}
            disabled={isProcessing}
          >
            {isProcessing ? "Processing..." : confirmLabel}
          </button>
        </div>
      </div>
    </Dialog>
  )
}
